import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const SyncFieldSettingsRecord = Record({
  id: null, // The id of what field/type/property/reference is being synced from the timeline
  customFieldId: null, // Scrivener only: for fields that sync with custom metadata fields, what is the field ID?
  customFieldName: null
});

createFromJS.registerCallback("SyncFieldSettingsRecord", createFromJS.createPrimitiveCallback(SyncFieldSettingsRecord));
